import { freddyTheme, Link as FreddyLink, Typography } from '@coolblue-development/freddy';
import Link from 'next/link';
import { ReactNode } from 'react';

export const HeaderLink = ({
  href = '#',
  onClick,
  variant = 'desktop',
  children
}: {
  href?: string;
  onClick?: () => void;
  variant?: 'desktop' | 'hamburger';
  children: ReactNode;
}) => {
  const isDesktopVariant = variant === 'desktop';

  return (
    <Typography
      component='li'
      variant={isDesktopVariant ? 'h3' : 'body'}
      color={isDesktopVariant ? 'white' : 'interactiveBase'}
      mb={0}
    >
      <FreddyLink
        component={Link}
        href={href}
        passHref
        onClick={onClick}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: freddyTheme.spacing[200],
          color: 'inherit',
          textDecoration: 'none',
          borderRadius: freddyTheme.borderRadius[100],

          '> svg': {
            width: '2.4rem',
            height: '2.4rem'
          },

          ...(isDesktopVariant
            ? {
                height: '4.4rem',
                padding: `0 ${freddyTheme.spacing[200]}`,

                '&:hover': {
                  backgroundColor: freddyTheme.color.background.interactiveInverseHovered
                }
              }
            : {
                '&:hover': {
                  textDecorationLine: 'underline'
                }
              })
        }}
      >
        {children}
      </FreddyLink>
    </Typography>
  );
};
